export const baseUrl = import.meta.env.VITE_API_URL;
// export const baseUrl = "https://iba-alumni.oss.net.bd/api/v1";

export const cmsBaseUrl = import.meta.env.VITE_CMS_API_URL;
